import React, { createRef, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { TabContext } from '@mui/lab'
import { Tab, Tabs, Tooltip, Typography } from '@mui/material'

import { flowConditionTabNames } from '../../../../../../constants'
import { Logger, LoggerTypes } from '../../../../../../utils'
import { Accordion, AccordionDetails, AccordionSummary, Icon, iconNames, TabPanel } from '../../../../../../components'
import { FlowElementStartAboutPanel } from '../FlowElementStartAboutPanel'
import '../../../common-elements-style.scss'
import './style.scss'

/**
 * @returns {div}
 */
export const FlowElementStartTab = ({
  currentProject,
  currentScenario,
  currentFlowGroup,
  currentElement,
  variables,
  // -- refresh after saving
  refreshAfterSave
}) => {
  const [tabValue, setTabValue] = useState(0)
  const { t } = useTranslation()
  const ref = createRef()

  // -- This variable is used to temporary locally save the changing start data between accordions
  // -- to be able to save in one place even if changes have been made in different accordion's forms.
  // const [currentStart, setCurrentStart] = useState(null)
  const [startTemp, setStartTemp] = useState(null)
  const [accordionExpanded, setAccordionExpanded] = useState(flowConditionTabNames.ABOUT)

  // -- Find the flow element action from the flowGroup data.
  // let _currentStart = (currentFlowGroup?.flows || []).map((flow) =>
  //   flow?.startAction?.element_id === currentElement.id ? flow : null
  // )
  const flowGroups = useSelector((state) => state.flowGroups)
  const flowGroupStartActions = flowGroups?.flowGroupStartActions.get(currentFlowGroup.id) || null
  const currentStart = flowGroupStartActions?.get(currentElement.id) || null

  useEffect(() => {
    Logger.trace(LoggerTypes.CONTROLLER, 'FlowElementStartTab.useEffect(...)', {
      flowGroups,
      currentFlowGroup,
      currentStart,
      currentElementId: currentElement.id
    })
    // setCurrentStart(__currentStart)
    // setStartTemp(currentStart)
  }, [currentElement, currentFlowGroup])

  const _getStartTemp = () => {
    return {
      ...startTemp
    }
  }

  const refreshStartTemp = () => {
    setStartTemp(_getStartTemp())
  }

  const onTabChange = (e, newTabValue) => {
    Logger.trace(LoggerTypes.CONTROLLER, 'FlowElementStartTab.onTabChange()', { e, newTabValue })
    setTabValue(newTabValue)
  }

  const onChangeAccordion = (panel) => (e, newExpanded) => {
    setAccordionExpanded(newExpanded ? panel : false)
    // setCurrentStart(currentStart)
    refreshStartTemp()
    Logger.trace(LoggerTypes.CONTROLLER, 'FlowElementStartTab.onChangeAccordion()', {
      newExpanded,
      currentStart
    })
  }

  // Logger.trace(LoggerTypes.CONTAINER, 'FlowElementStartTab.render()', {
  //   tabValue,
  //   currentElement,
  //   currentProject,
  //   currentScenario,
  //   currentFlowGroup,
  //   currentStart
  // })

  return currentStart ? (
    <div className="FlowElementStartTab">
      <TabContext value={tabValue}>
        <Tabs value={tabValue} onChange={onTabChange}>
          <Tooltip ref={ref} title={t('flowActions.starts.tabs.about')}>
            <Tab disableRipple={true} id="simple-tab-0" icon={<Icon name={iconNames.ABOUT} size={20} />} />
          </Tooltip>
        </Tabs>
        {/*  -- ABOUT --  */}
        <TabPanel value={tabValue} index={0}>
          <Accordion
            expanded={accordionExpanded === flowConditionTabNames.ABOUT}
            onChange={onChangeAccordion(flowConditionTabNames.ABOUT)}
          >
            <AccordionSummary
              aria-controls={`${flowConditionTabNames.ABOUT}-content`}
              id={`${flowConditionTabNames.ABOUT}-header`}
            >
              <Typography>
                <Icon name={iconNames.ABOUT} size={12} />
                <span className="iconAccordion">{t('flowActions.start.panels.about.title')}</span>
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <FlowElementStartAboutPanel
                currentProject={currentProject}
                currentScenario={currentScenario}
                currentFlowGroup={currentFlowGroup}
                currentStart={currentStart}
                variables={variables}
                refreshAfterSave={refreshAfterSave}
              />
            </AccordionDetails>
          </Accordion>
        </TabPanel>
      </TabContext>
    </div>
  ) : (
    <div></div>
  )
}

FlowElementStartTab.displayName = 'FlowElementStartTab'

FlowElementStartTab.propTypes = {
  currentProject: PropTypes.object.isRequired,
  currentScenario: PropTypes.object.isRequired,
  currentFlowGroup: PropTypes.object.isRequired,
  currentElement: PropTypes.object,
  variables: PropTypes.any,
  // -- refresh after saving
  refreshAfterSave: PropTypes.func
}

FlowElementStartTab.defaultProps = {
  currentProject: null,
  currentScenario: null,
  currentFlowGroup: null,
  currentElement: null,
  variables: null,
  // -- refresh after saving
  refreshAfterSave: null
}
